import thunk from 'redux-thunk';
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { routerReducer } from 'react-router-redux';

import shows from './reducers/shows';

const rootReducer = combineReducers({
   shows,  
   routing: routerReducer
});

export default createStore(
   rootReducer,
   applyMiddleware(thunk)
);
